import React from 'react';

//Use to pass 'loading' information down.
//Expect all child components (That support it) to display a loading indicator or styling when 'loading' is set to true.
const LoadingContext = React.createContext({ loading: false });
export default LoadingContext;
